import { isPlatformBrowser } from '@angular/common';
import { LoggerService } from './../logger/logger.service';
import { ConfigService } from './../config/config.service';
import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Logger } from '../logger/logger';
import { ResponseNniToken, ConsumerCreditLauncherService } from './consumer-credit-launcher.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-consumer-credit-launcher',
  template: `
    <p>
      <app-frame-partner
        *ngIf="simulatorToken"
        id="loanSimulator"
        [nnih]="simulatorToken"
        [urlFunction]="urlFunction"
        width="100%"
        height="100%"
      >
      </app-frame-partner>
    </p>
  `,
  styleUrls: ['./consumer-credit-launcher.component.scss'],
  providers: [ConsumerCreditLauncherService],
})
export class ConsumerCreditLauncherComponent implements OnInit, OnDestroy {
  simulatorToken: string;
  urlFunction: string;
  isBrowser: boolean;

  private logger: Logger;
  private subscription: Subscription;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly loggerService: LoggerService,
    private readonly configService: ConfigService,
    private readonly consumerCreditLauncherService: ConsumerCreditLauncherService,
    @Inject(PLATFORM_ID) private platformId: string,

  ) {
    this.logger = this.loggerService.get(ConsumerCreditLauncherComponent.name);
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    if(this.isBrowser) {
      const idProcess = this.route.snapshot.params.processId;
      this.urlFunction = this.configService.get('API_SIMULATOR_IHM_URL');
      this.subscription = this.getSimulatorToken(idProcess);
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  getSimulatorToken(idProcess: string): Subscription {
    return this.consumerCreditLauncherService.getSimulatorToken(idProcess).subscribe(
      ({ nniToken }: ResponseNniToken) => {
        this.simulatorToken = nniToken;
      },
      (error) => {
        try {
        this.logger.error(JSON.stringify(error));
        } catch(err) {
          this.logger.error(error);
        }
      },
    );
  }
}
